import en from "./en";
import cn from "./cn";
import cntw from "./cntw";
export default {
  en,
  cn,
  cntw
}
